import { convertMsToTime } from '@/utils/time.utils';

export function experimentActivatedTrackEvent (experiment) {
    const { attributionWindow, itemId, itemType } = experiment.conversion;
    const { variants } = experiment;
    const conversionMetricSet = !!itemId && !!itemType;

    const attributionWindowHrs = convertMsToTime(attributionWindow, 'HOUR');
    const duration = experiment.endTime - experiment.startTime;
    const experimentDurationDays = Math.floor(convertMsToTime(duration, 'DAY'));

    window.pendo.track('experiment-activated', {
        conversionMetricSet,
        conversionAttrWindowHrs: conversionMetricSet ? attributionWindowHrs : 0,
        conversionItemType: conversionMetricSet ? itemType : '',
        experimentDurationDays,
        variantASize: variants[0].groupSize,
        variantBSize: variants[1].groupSize,
    });
}
